import React from 'react'
import { useTranslation } from 'react-i18next'

const CreditsHeader = () => {
	const { t } = useTranslation()

	return (
			<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-start'
					}}
			>
				<h2
						style={{
							fontSize: 18,
							fontWeight: '600'
						}}
				>
					{t("taxCorePages.dashboard.credits")}
				</h2 >
			</div >
	)
}

export default CreditsHeader
